<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'title.enterprise_waiting_initial_doc_all'| translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{'enterprise_contract.ttl_search' | translate}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
          <div class="row">

            <!-- Tên/Mã tài liệu -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()"
                       #focusInput matInput [placeholder]="'search_form.doc_name_or_code' | translate" name="nameOrCode"
                       [(ngModel)]="documents.nameOrCode" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.nameOrCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Email/tên khách hàng -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.customer = documents.customer == undefined ? '' : (documents.customer + '').trim()"
                       matInput [placeholder]="'search_form.custommer_name_or_email' | translate" name="customer"
                       [(ngModel)]="documents.customer" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.customer" type="button" matSuffix mat-icon-button aria-label="Clear"
                        (click)="documents.customer=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Trạng thái -->
            <div class="col-lg-4 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.status' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                            [(ngModel)]="documents.status" (ngModelChange)="onSearch(0, paginate.pageSize)">
                  <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.PROCESSING"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_initial_no_process' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.PROCESSED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_initial_process' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.REJECTED"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_rejected' | translate}}</mat-option>
                  <mat-option [value]="contractUserStatus.NO_PROCESS"
                              (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.contract_user_status_stop_process' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Tên của người chuyển -->
            <div class="col-md-6 col-lg-4" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <input type="text"
                       (focusout)="documents.createdUser = documents.createdUser == undefined ? '' : (documents.createdUser + '').trim()"
                       matInput [placeholder]="'search_form.forward_by' | translate" name="createdUser"
                       [(ngModel)]="documents.createdUser" maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.createdUser" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="documents.createdUser=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>

            <!-- Thời gian nhận (từ ngày) -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_from' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeFrom" #receivedTimeFromCtrl="ngModel"
                       (focus)="receivedDateErr = 'fromDate'"
                       (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['receivedTimeFrom'])"
                       name="receivedTimeFrom" #pickerInput [(ngModel)]="documents.receivedTimeFrom" maxlength="200"
                       [max]="documents.receivedTimeTo" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeFrom">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeFrom></mat-datepicker>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeFromCtrl?.errors?.matDatepickerMax && receivedDateErr == 'fromDate'">
                  {{ 'search_form.received_date_from' | translate }}
                  {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                  {{ 'search_form.received_date_to' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Thời gian nhận (đến ngày) -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{ 'search_form.received_date_to' | translate }}</mat-label>
                <input matInput [matDatepicker]="receivedTimeToRef" [min]="documents.receivedTimeFrom"
                       (focus)="receivedDateErr = 'toDate'"
                       (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['receivedTimeTo'])"
                       name="receivedTimeTo" #pickerInput1 [(ngModel)]="documents.receivedTimeTo"
                       #receivedTimeToCtrl="ngModel" maxlength="200" autocomplete="off"/>
                <mat-datepicker-toggle matSuffix [for]="receivedTimeToRef">
                  <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                     [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                </mat-datepicker-toggle>
                <mat-datepicker #receivedTimeToRef></mat-datepicker>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerParse">
                  {{'validation.format_of_date' | translate}}
                </mat-error>
                <mat-error *ngIf="receivedTimeToCtrl?.errors?.matDatepickerMin && receivedDateErr == 'toDate'">
                  {{ 'search_form.received_date_to' | translate }}
                  {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                  {{ 'search_form.received_date_from' | translate }}
                </mat-error>
              </mat-form-field>
            </div>

            <!-- Loại dịch vụ -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm">
              <mat-form-field class="w-100">
                <mat-label>{{'form.service_type' | translate}}</mat-label>
                <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                            [disabled]="!myForm.valid" name="serviceType" [(ngModel)]="documents.type"
                            (ngModelChange)="onSearch(0, paginate.pageSize)">
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                           [placeholderLabel]="'search_form.search' | translate"
                                           [formControl]="serviceTypeByEnterpriseFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option value="null" selected
                              (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                    {{'form.select_all' | translate}}
                  </mat-option>
                  <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                    <i class="fa fa-circle-o-notch fa-spin"></i>
                  </div>
                  <mat-option *ngFor="let serviceType of filteredServiceTypeByEnterprise | async" [value]="serviceType.id"
                              (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                    {{serviceType.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- Nguồn hợp đồng -->
            <div class="col-lg-4 col-md-6" *ngIf="!isBasicSearchForm && userType !== PermissionConfig.USER_ENTERPRISE_DOCUMENT">
              <mat-form-field class="w-100">
                <mat-label>{{'form.contract_source' | translate}}</mat-label>
                <mat-select #contractSourceSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                            (focus)="commonService.openComboBox(checkFocus, contractSourceSelect)" id="contractSource" name="contractSource"
                            [(ngModel)]="documents.contractSource" (ngModelChange)="onSearch(0, paginate.pageSize)">
                  <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.contractSourceSelect)">
                    {{'form.contract_source_all' | translate}}</mat-option>
                  <mat-option [value]="1"
                              (click)="this.commonService.closeDropdownList(this.contractSourceSelect)">
                    {{'form.contract_source_company' | translate}}</mat-option>
                  <mat-option [value]="2"
                              (click)="this.commonService.closeDropdownList(this.contractSourceSelect)">
                    {{'form.contract_source_partner' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- button up/down -->
            <div class="col-lg-12 col-md-6 d-flex justify-content-end">
              <button *ngIf="!isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onCloseAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                <em class="material-icons">keyboard_arrow_up</em>
              </button>
              <button *ngIf="isBasicSearchForm" type="button" mat-button class="advance-search"
                      (click)="onExpandAdvancedSearchForm()">
                <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                <em class="material-icons">keyboard_arrow_down</em>
              </button>
            </div>
          </div>

          <!-- button tìm kiếm -->
          <div class="row mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" appTrackEvent="w.btn.hd_ky_nhay.tim_kiem"
                      [disabled]="!myForm.valid || isTableLoading">
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_document_template.buttons.search' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mb-2 mt-3 d-flex justify-content-between align-items-center list-title">
          <!-- Header title -->
          <div class="title  pl-0 ">
            <span class="mt-4">{{'enterprise_contract.list_document_wait_initial' | translate}}
              ({{paginate.totalRow}}), {{'enterprise_contract.selected_title' | translate}}
              : {{selection.selected.length}}
            </span>
          </div>

          <div class="d-flex justify-content-end">
            <button class="" mat-stroked-button color="primary" type="button" appTrackEvent="w.btn.hd_ky_nhay.tai_hd"
                    [disabled]="selection.selected.length === 0" (click)="multiDownload()">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'button.downloadContract' | translate}}
            </button>

            <button [matMenuTriggerFor]="menuColumn" [matTooltip]="'bodytable.status_column' | translate" class="ml-1"
                    style=" width: 35px; padding: 7px 5px 3px 5px;border-radius: 5px;border: 1px solid #bdbdbd;  align-items: center;"  color="primary" type="button"
            >
              <mat-icon>more_vert</mat-icon>
            </button >
            <mat-menu #menuColumn="matMenu"  >
              <mat-checkbox style="margin: 0px 15px" [(ngModel)]="isCheckedAllColumn" (click)="$event.stopPropagation()" (change)="onAllColumnCheckboxChange(isCheckedAllColumn)"
              >{{ 'form.select_all_group' | translate}}</mat-checkbox>
              <div *ngFor="let option of columnDefinitions">
                <mat-checkbox style="margin: 0px 15px" [(ngModel)]="option.default" (change)="onCheckboxChange(option)" (click)="$event.stopPropagation()"
                              [checked]="option.default" *ngIf="!option.check"
                >{{ option.name | translate}}</mat-checkbox>
              </div>
            </mat-menu>
          </div>

          <ng-template #showSigningBackground>
            <div class="mt-3 col-8 ml-4" layout-align="center center end-start">
              <div class="row">
                <div class="col-11">
                  <span>{{'messages.signing_progress' | translate}} {{processedPercent}}%</span>
                  <mat-progress-bar mode="determinate" [value]="processedPercent" [bufferValue]="100">
                  </mat-progress-bar>
                </div>
                <div class="col-1" layout="row" layout-align="end center">
                  <button mat-icon-button color="primary" (click)="openSigningProgressPopup()" matTooltip="">
                    <mat-icon>gesture</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-panel-title>

        <div class="mat-table-container"  style=" display: block;max-height: 590px">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"  [ngStyle]="{'min-width': tableWidth + 'px'}">
            <!-- select -->
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox
                  *ngIf="dataSource && dataSource.data && dataSource.data.value && dataSource.data.value.length > 0"
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox
                  color="primary"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(element.id) : null"
                  [checked]="selection.isSelected(element.id)"
                >
                </mat-checkbox>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell check-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.STT}}
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tài liệu Column -->
            <ng-container matColumnDef="contractName">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.document_code_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Khách hàng Column -->
            <ng-container matColumnDef="allName">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                <span class="fix-width">{{ element.allName}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Email các bên ký hợp đồng Column -->
            <ng-container matColumnDef="allEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties_email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 20%;">
                <span class="fix-width">{{ element.allEmail }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 20%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'form.status_process' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <!-- {{ element.status }} - {{ element.cStatus }} -->
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSING && element.cStatus === 2"
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_initial_no_process' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSED" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_initial_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="(element.status === contractUserStatus.NO_PROCESS && (element.cStatus === 5 || element.cStatus === 3 || element.cStatus === 4)) || (element.status === contractUserStatus.PROCESSING && element.cStatus === 4)"
                  style="margin-right: 0px;">{{'search_form.contract_user_status_stop_process' | translate}}
                </nz-tag>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- người chuyển -->
            <ng-container matColumnDef="createdUser">
              <mat-header-cell *matHeaderCellDef style="max-width: 11%;" mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <span>
                  {{'enterprise_contract.table_headers.forward_by' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.createdUser }}"
                        (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                        style="max-width: 11%;">
                <span class="fix-width">{{ element.createdUser }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 11%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Thời gian nhận Column -->
            <ng-container matColumnDef="receivedTime">
              <mat-header-cell *matHeaderCellDef mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 10%">
                {{'headertable.received_time' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="element.receivedTime | dateformat"
                        (click)="$event.stopPropagation()" style="max-width: 10%">
                <span class="fix-width">{{ element.receivedTime | dateformat}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 10%">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- nguoi lap -->
            <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.created_by' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.createdBy }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 7%; justify-content: center;">
                <span class="fix-width">{{ element.createdBy }}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 7%; justify-content: center;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!--Ngày hết hiệu lực Column -->
            <ng-container matColumnDef="expiredDate">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 12%;">
                {{'enterprise-certificate_management.lbl_end_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="element.expiredDate | dateformat"
                        (click)="$event.stopPropagation()" style="max-width: 12%;">
                <span class="fix-width">{{ element.expiredDate | dateformat}}</span>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 12%;">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol ">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col-3 mat-cell-non-border-bottom"
                               style="min-width: 100px;">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col-3 mat-cell-non-border-bottom"
                        style="min-width: 100px" (click)="$event.stopPropagation()">
                <button mat-icon-button (click)="viewDetail(element)"  appTrackEvent="w.btn.hd_ky_nhay.xem_chi_tiet"
                        matTooltip="{{'enterprise_contract.buttons.view' | translate}}">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button (click)="openPDFByBrowser(element)" appTrackEvent="w.btn.hd_ky_nhay.tai_file">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>
              </mat-cell>
              <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell action-col-3" style="min-width: 100px">
                <span class="skeleton-cell"></span>
              </mat-footer-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
                     (toggleChange)="onToggleChange($event,row)">
            </mat-row>
            <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                 ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng can theo
                 displayedColumns nen skeleton can theo dung cot; an/hien qua class theo isTableLoading -->
            <mat-footer-row *matFooterRowDef="displayedColumns"
            class="table-skeleton-row"
            [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
          </mat-table>
          </div>

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)" [isShowNoRecord]="!isTableLoading">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
